import React, { ReactNode } from 'react'
import { Stack, SxProps, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'

export type TagProps = {
    label: ReactNode
    color?: string
    backgroundColor?: string
    startIcon?: ReactNode
    sx?: SxProps<Theme>
}

export const Tag = ({
    label,
    color = 'figma.accentColors.white',
    backgroundColor = 'figma.grayscale.tier4',
    startIcon,
    sx = [],
}: TagProps) => (
    <Stack
        display="inline-flex"
        direction="row"
        alignItems="center"
        gap={startIcon ? 0.75 : 0}
        px={1.5}
        py={0.5}
        borderRadius="16px"
        bgcolor={backgroundColor}
        sx={sx}
    >
        {startIcon}
        <Typography variant="14x400" color={color} whiteSpace="nowrap">
            {label}
        </Typography>
    </Stack>
)

export default Tag
